export default class AgeGate extends HTMLElement {
  constructor() {
    super();

    this.confirmButtons = this.querySelectorAll(".age-gate-confirm");
    this.declineButton = this.querySelector("#age-gate-decline");
    this.ageGateTime = this.getAttribute("data-age-gate-time");
    this.ageGateContent = this.querySelector("#age-gate-content");

    this.declineBox = this.querySelector("#decline-box");
    this.confirmBox = this.querySelector("#confirm-box");
    this.leaveAfterDeclineButton = this.querySelector("#leave-after-decline");

    this.bgImageMobileLeft = this.querySelector(
      "#age-gate-bg-image-mobile-left",
    );
    this.bgImageMobileRight = this.querySelector(
      "#age-gate-bg-image-mobile-right",
    );
    this.bgImageDesktopLeft = this.querySelector(
      "#age-gate-bg-image-desktop-left",
    );
    this.bgImageDesktopRight = this.querySelector(
      "#age-gate-bg-image-desktop-right",
    );
  }

  connectedCallback() {
    this.confirmButtons.forEach((button) =>
      button.addEventListener("click", () => this.verifyAge(true)),
    );
    this.declineButton.addEventListener("click", () => this.verifyAge(false));

    this.leaveAfterDeclineButton.addEventListener("click", () => {
      window.history.back();
    });

    // During prerender the page runs in a hidden background context.
    // Skip the gate entirely — it will re-check on actual activation.
    if (document.prerendering) {
      document.addEventListener('prerenderingchange', () => this.checkCookie(), { once: true });
      return;
    }

    this.checkCookie();
  }

  checkCookie() {
    const ageVerified = this.getCookie("age_verified");
    if (ageVerified === "true") {
      this.classList.add("hidden");
    } else {
      this.showGate();
    }
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    // date.setTime(date.getTime() + 3000);

    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
  }

  getCookie(name) {
    const cookies = document.cookie.split(";");
    for (let c of cookies) {
      c = c.trim();
      if (c.startsWith(name + "=")) return c.substring(name.length + 1);
    }
    return null;
  }

  verifyAge(isAdult) {
    console.log("verifyAge", isAdult);
    if (isAdult) {
      this.setCookie("age_verified", "true", this.ageGateTime);
      this.hideGate();
    } else {
      this.declineBox.classList.remove("invisible");
      this.declineBox.classList.remove("opacity-0");
      this.declineBox.classList.remove("h-0");
      this.declineBox.classList.remove("translate-y-5");
      this.confirmBox.classList.add("opacity-0");
      this.confirmBox.classList.add("h-0");
      this.confirmBox.classList.add("invisible");
    }
  }

  showGate() {
    console.log("showGate");
    this.classList.add("fixed", "inset-0", "z-10000");
    this.classList.remove("hidden");
  }

  hideGate() {
    this.bgImageMobileLeft.classList.add("animate-gate-close-left");
    this.bgImageMobileRight.classList.add("animate-gate-close-right");
    this.bgImageDesktopLeft.classList.add("animate-gate-close-left");
    this.bgImageDesktopRight.classList.add("animate-gate-close-right");
    this.ageGateContent.style.opacity = 0;
    setTimeout(() => {
      this.classList.remove("fixed", "inset-0", "z-10000");
      this.classList.add("hidden");
    }, 2200);
  }
}

customElements.define("age-gate", AgeGate);
